import React from 'react'
import { styled, YStack } from 'tamagui'

export const accentColors = {
  orange: '#FF6300',
  amber: '#FF9D3A',
  dim: '#666666',
} as const

export type Accent = keyof typeof accentColors

export function getAccentColor(accent?: Accent): string {
  return accent ? accentColors[accent] : accentColors.orange
}

export function getAccentGlow(accent?: Accent): string {
  const color = getAccentColor(accent)
  return `0 0 20px ${color}40`
}

const LINK_RE = /\[([^\]]+)\]\(([^)]+)\)/g

export function parseLinkedText(text: string, color?: string): React.ReactNode {
  if (!LINK_RE.test(text)) return text
  LINK_RE.lastIndex = 0
  const c = color || accentColors.orange
  const linkStyle = `color:${c};text-decoration:underline;text-decoration-color:${c}60;text-underline-offset:3px;cursor:pointer;pointer-events:auto;position:relative;z-index:10`
  const parts: string[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null
  while ((match = LINK_RE.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index).replace(/&/g, '&amp;').replace(/</g, '&lt;'))
    }
    const label = match[1].replace(/&/g, '&amp;').replace(/</g, '&lt;')
    const href = match[2].replace(/&/g, '&amp;').replace(/"/g, '&quot;')
    parts.push(`<a href="${href}" target="_blank" rel="noopener noreferrer" style="${linkStyle}">${label}</a>`)
    lastIndex = match.index + match[0].length
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex).replace(/&/g, '&amp;').replace(/</g, '&lt;'))
  }
  return React.createElement('span', { dangerouslySetInnerHTML: { __html: parts.join('') } })
}

export const SlideContainer = styled(YStack, {
  name: 'SlideContainer',
  width: '100%',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
})

export const SlideInner = styled(YStack, {
  name: 'SlideInner',
  width: '100%',
  maxWidth: 1200,
  gap: '$6',
})
